import { useState, useCallback } from 'react';

export function useQueue(initialQueue = []) {
  const [queue, setQueue] = useState(initialQueue);

  const addNext = useCallback((track) => setQueue((q) => [track, ...q]), []);
  const addToEnd = useCallback((track) => setQueue((q) => [...q, track]), []);
  const remove = useCallback(
    (trackId) => setQueue((q) => q.filter((t) => t.id !== trackId)),
    []
  );
  const clear = useCallback(() => setQueue([]), []);
  const reorder = useCallback(
    (fromIdx, toIdx) =>
      setQueue((q) => {
        const next = [...q];
        const [item] = next.splice(fromIdx, 1);
        next.splice(toIdx, 0, item);
        return next;
      }),
    []
  );
  const pop = useCallback(() => {
    let popped;
    setQueue((q) => {
      if (q.length === 0) return q;
      const [first, ...rest] = q;
      popped = first;
      return rest;
    });
    return popped;
  }, []);

  return {
    queue,
    setQueue,
    addNext,
    addToEnd,
    remove,
    clear,
    reorder,
    pop,
  };
}
